var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigation = function SvgNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 88 93"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#navigation_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__b",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 8H8v72h72z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44 76.914c18.154 0 32.914-14.76 32.914-32.914S62.154 11.086 44 11.086 11.086 25.846 11.086 44 25.846 76.914 44 76.914"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__c",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80 44c0 19.903-16.097 36-36 36S8 63.903 8 44 24.097 8 44 8s36 16.097 36 36"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__d",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M44 74.189c16.663 0 30.19-13.526 30.19-30.189S60.662 13.812 44 13.812c-16.662 0-30.188 13.525-30.188 30.188s13.526 30.189 30.189 30.189"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__e",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44.875 46.674-.103 1.234 1.594-.257-.051.72-1.594.258-.206 2.828c-.051.669.154.977.771.874.309-.051.463-.103.669-.154v.72c-.206.103-.566.206-.977.309-.514.102-.926 0-1.183-.206-.257-.257-.36-.669-.309-1.286l.206-2.88-.926.154.052-.72.925-.154.052-.977z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__f",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M52.898 49.194c-.154 1.955-1.749 3.035-3.24 3.24-1.646.258-2.829-.565-2.726-2.211.103-1.749 1.543-2.983 3.189-3.24 1.8-.309 2.88.617 2.777 2.211m-4.783.823c-.103 1.132.617 1.903 1.697 1.749 1.029-.154 1.903-1.132 2.006-2.314.051-.875-.36-1.903-1.697-1.698-1.286.155-1.955 1.286-2.006 2.263"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__g",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.274 49.4c-.051.566-.051 1.029-.051 1.44l-.977.154v-.823h-.052a3 3 0 0 1-2.057 1.286c-.977.154-2.057-.154-1.954-1.954l.206-3.086 1.08-.154-.206 2.88c-.052.977.257 1.645 1.234 1.44.72-.103 1.286-.617 1.492-1.132.051-.154.102-.308.154-.514l.206-3.188 1.08-.155z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__h",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.28 46.931c.051-.617.051-1.131.051-1.645l.977-.155v1.029h.052c.309-.771 1.029-1.286 1.749-1.44.102 0 .205 0 .308-.051l-.051.874c-.103 0-.206 0-.36.051-.772.103-1.389.72-1.543 1.44-.052.155-.052.309-.052.463l-.205 2.777-1.08.155z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__i",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M65.034 48.937c.31.103.875.206 1.44.155.772-.103 1.183-.515 1.235-.978.051-.462-.257-.668-1.029-.771-1.08-.154-1.543-.617-1.491-1.234.051-.823.926-1.646 2.211-1.852.617-.103 1.132-.051 1.44.103l-.308.72c-.206-.103-.669-.206-1.235-.103-.668.103-1.028.463-1.028.875-.052.41.308.565 1.08.72 1.028.154 1.543.514 1.491 1.337-.051.925-.925 1.697-2.365 1.954-.67.103-1.286.051-1.698-.103z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__j",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.32 47.189s3.394-.463 3.96-3.395c0 0 .36-2.314-2.52-1.645 0 0-1.594.257-2.057 3.085l-.874 8.486-2.572.411.823-9.051s.514-4.474 4.68-5.246c0 0 3.703-.72 4.937 2.006 0 0 1.749 4.783-3.857 7.097 0 0-2.109.772-2.674.874z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__k",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.063 38.446-2.674.411-.617 8.435 2.623-.412z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__l",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.812 38.292s.206.154.823 0c0 0 2.057-1.08 2.571-1.44 0 0 2.675-1.543 4.372-.103 0 0 4.32-3.138 6.171-.566 0 0 .72.514.309 3.24l-.309 4.834-2.88.515s.206-.72.309-2.88c0 0 .308-3.6.205-3.806-.102-.206-.154-.514-.514-.514 0 0-2.417.72-2.623 1.182l-.411 6.378-2.777.514s.617-6.223.514-6.583c-.103-.412-.257-.514-.72-.412 0 0-1.08.155-2.469 1.183l-.411 6.275-2.726.411z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__m",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.72 39.834s-3.703 1.44-4.217 2.263l-.463 5.914-2.571.463.514-8.28s.206.103 1.08 0c0 0 3.446-2.057 5.04-2.468z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__n",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.8 33.766s-4.217-1.286-6.84 2.828c0 0-3.189 5.452 2.417 6.84 0 0 4.474.875 6.686-3.96 0 0 1.903-4.165-2.263-5.708"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__o",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F07800",
    d: "M62.668 36.08s-2.262-.566-3.343 1.491c0 0-1.594 2.778.669 3.6 0 0 2.469.463 3.446-2.057.051-.051.823-2.365-.772-3.034"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__p",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.812 32.017-.36-.977-.412.977z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__q",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.965 32.069.515.565.411-.977"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__r",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m68.582 33.509.977-.412-.977-.36z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__s",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m68.53 33.663-.514.514.926.412"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__t",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.04 34.28.411.977.36-.977z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__u",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.886 34.177-.515-.514-.411.977"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__v",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__v)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.269 32.789-.926.36.926.36z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__w",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m66.371 32.634.515-.514-.977-.463"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__x",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__x)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.532 33.149c0 .617-.463 1.08-1.08 1.08s-1.08-.463-1.08-1.08c0-.618.514-1.08 1.08-1.08s1.08.462 1.08 1.08"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "navigation_svg__y",
    width: 72,
    height: 72,
    x: 8,
    y: 8,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 44c0 19.903 16.097 36 36 36s36-16.097 36-36S63.903 8 44 8 8 24.097 8 44"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navigation_svg__y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D47519",
    d: "M67.451 34.383a1.25 1.25 0 0 1-1.234-1.234c0-.669.566-1.235 1.234-1.235.669 0 1.235.566 1.235 1.235-.052.668-.566 1.234-1.235 1.234m0-2.212a.977.977 0 0 0-.977.978c0 .565.412.977.977.977a.976.976 0 1 0 0-1.955"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "navigation_svg__a",
    width: 82,
    height: 89,
    x: 3,
    y: 4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_429_43865"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_429_43865",
    result: "effect2_dropShadow_429_43865"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_429_43865",
    result: "effect3_dropShadow_429_43865"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_429_43865",
    result: "effect4_dropShadow_429_43865"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.937255 0 0 0 0 0.466667 0 0 0 0 0.00392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_429_43865",
    result: "effect5_dropShadow_429_43865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_429_43865",
    result: "shape"
  })))));
};
export default SvgNavigation;